module.exports = __webpack_public_path__ + "img/united-arab-emirates.60a4a62f.svg";